
      if (import.meta.env.DEV || window.location.hostname.replace(/^www\./, "") === "setflows.com") {
        document.title = "Setflows";
        document.querySelectorAll('link[rel="icon"]').forEach((link) => link.remove());
        const icon = document.createElement("link");
        icon.rel = "icon";
        icon.type = "image/svg+xml";
        icon.href = "/setflows/favicon.svg";
        document.head.appendChild(icon);
        document.querySelector('link[rel="apple-touch-icon"]').href = "/setflows/apple-touch-icon.png";
        document.querySelector('meta[name="theme-color"]').content = "#FAF9F6";
      }
    